/// <reference path="../../../../../typings/tsd.d.ts" />
/// <reference path="api.d.ts" />

/* tslint:disable:no-unused-variable member-ordering */

namespace API.Client {
    'use strict';

    export class AddressApi {
        protected basePath = '/proxy/oag/gwt-commons/AddressesRestService';
        public defaultHeaders : any = {};

        static $inject: string[] = ['$http', '$httpParamSerializer'];

        constructor(protected $http: ng.IHttpService, protected $httpParamSerializer?: (d: any) => any, basePath?: string) {
            if (basePath) {
                this.basePath = basePath;
            }
        }

        private extendObj<T1,T2>(objA: T1, objB: T2) {
            for(let key in objB){
                if(objB.hasOwnProperty(key)){
                    objA[key] = objB[key];
                }
            }
            return <T1&T2>objA;
        }

        /**
         * List of States
         * Busca de estados\n
         * @param countryCode Country code
         */
        public addressesCountriesCountryCodeStatesGet (countryCode: string, extraHttpRequestParams?: any ) : ng.IHttpPromise<StatesResponse> {
            const localVarPath = this.basePath + '/addresses/countries/{countryCode}/states'
                .replace('{' + 'countryCode' + '}', String(countryCode));

            let queryParameters: any = {};
            let headerParams: any = this.extendObj({}, this.defaultHeaders);
            // verify required parameter 'countryCode' is set
            if (!countryCode) {
                throw new Error('Missing required parameter countryCode when calling addressesCountriesCountryCodeStatesGet');
            }
            let httpRequestParams: any = {
                method: 'GET',
                url: localVarPath,
                json: true,
                                                params: queryParameters,
                headers: headerParams
            };

            if (extraHttpRequestParams) {
                httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
            }

            return this.$http(httpRequestParams);
        }
        /**
         * List of cities
         * Busca de paises\n
         * @param countryCode c\u00F3digo de pais para busca
         * @param stateCode c\u00F3digo do estado para busca
         */
        public addressesCountriesCountryCodeStatesStateCodeCitiesGet (countryCode: string, stateCode: string, extraHttpRequestParams?: any ) : ng.IHttpPromise<CitiesResponse> {
            const localVarPath = this.basePath + '/addresses/countries/{countryCode}/states/{stateCode}/cities'
                .replace('{' + 'countryCode' + '}', String(countryCode))
                .replace('{' + 'stateCode' + '}', String(stateCode));

            let queryParameters: any = {};
            let headerParams: any = this.extendObj({}, this.defaultHeaders);
            // verify required parameter 'countryCode' is set
            if (!countryCode) {
                throw new Error('Missing required parameter countryCode when calling addressesCountriesCountryCodeStatesStateCodeCitiesGet');
            }
            // verify required parameter 'stateCode' is set
            if (!stateCode) {
                throw new Error('Missing required parameter stateCode when calling addressesCountriesCountryCodeStatesStateCodeCitiesGet');
            }
            let httpRequestParams: any = {
                method: 'GET',
                url: localVarPath,
                json: true,
                                                params: queryParameters,
                headers: headerParams
            };

            if (extraHttpRequestParams) {
                httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
            }

            return this.$http(httpRequestParams);
        }
        /**
         * List of Countries
         * Returns all countries\n
         */
        public addressesCountriesGet (extraHttpRequestParams?: any ) : ng.IHttpPromise<CountriesResponse> {
            const localVarPath = this.basePath + '/addresses/countries';

            let queryParameters: any = {};
            let headerParams: any = this.extendObj({}, this.defaultHeaders);
            let httpRequestParams: any = {
                method: 'GET',
                url: localVarPath,
                json: true,
                                                params: queryParameters,
                headers: headerParams
            };

            if (extraHttpRequestParams) {
                httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
            }

            return this.$http(httpRequestParams);
        }
        /**
         * Returns a list of addresses based on request
         * Returns de endere\u00E7o por CEP\n
         * @param cep CEP do endere\u00E7o de busca
         */
        public addressesGet (cep: number, extraHttpRequestParams?: any ) : ng.IHttpPromise<AddressesResponse> {
            const localVarPath = this.basePath + '/addresses';

            let queryParameters: any = {};
            let headerParams: any = this.extendObj({}, this.defaultHeaders);
            // verify required parameter 'cep' is set
            if (!cep) {
                throw new Error('Missing required parameter cep when calling addressesGet');
            }
            if (cep !== undefined) {
                queryParameters['cep'] = cep;
            }

            let httpRequestParams: any = {
                method: 'GET',
                url: localVarPath,
                json: true,
                                                params: queryParameters,
                headers: headerParams
            };

            if (extraHttpRequestParams) {
                httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
            }

            return this.$http(httpRequestParams);
        }
    }
}
